import { render, staticRenderFns } from "./GoalsForEmployee.vue?vue&type=template&id=bd51159c"
import script from "./GoalsForEmployee.vue?vue&type=script&lang=js"
export * from "./GoalsForEmployee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports